const firebaseConfig = {
  apiKey: "AIzaSyCThYtHck7A79lJK-P0-sVdfOh3r8z7GSw",
  authDomain: "electro-4e925.firebaseapp.com",
  projectId: "electro-4e925",
  storageBucket: "electro-4e925.appspot.com",
  messagingSenderId: "58833218200",
  appId: "1:58833218200:web:b3e654967b873d7ed77eed",
};
export default firebaseConfig;
